import { Injectable, inject } from '@angular/core';
import { Observable, Subject, map, of, tap } from 'rxjs';

import { GeneralMeetingsResource } from './resources/general-meetings.resource';

@Injectable({
    providedIn: 'root'
})
export class GeneralMeetingCheckInService {
    private isCheckedIn?: boolean;
    private isCheckedInSubject = new Subject<boolean>();

    private readonly generalMeetingsResource = inject(GeneralMeetingsResource);

    getStatus(): Observable<boolean> {
        if (this.isCheckedIn === undefined) {
            return this.generalMeetingsResource.getCurrentCheckedInForShareholder().pipe(
                map(response => response.value),
                tap(isCheckedIn => (this.isCheckedIn = isCheckedIn))
            );
        }

        return of(this.isCheckedIn);
    }

    checkInStatusChange(): Observable<boolean> {
        return this.isCheckedInSubject.asObservable();
    }

    checkIn(successCallback?: () => void): void {
        this.generalMeetingsResource.checkIn().subscribe(() => {
            this.updateStatus(true);
            if (!!successCallback) {
                successCallback();
            }
        });
    }

    checkOut(successCallback?: () => void): void {
        this.generalMeetingsResource.checkOut().subscribe(() => {
            this.updateStatus(false);
            if (!!successCallback) {
                successCallback();
            }
        });
    }

    private updateStatus(isCheckedIn: boolean): void {
        this.isCheckedIn = isCheckedIn;
        this.isCheckedInSubject.next(isCheckedIn);
    }
}
